import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import {
  dailyActivityActions,
  getDailyActivityById,
  updateDailyActivity,
} from "../../../redux/reducer/dailyActivity/dailyActivityReducer";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { getActivity } from "../../../redux/reducer/activity/activityReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerDailyActivityEdit() {
  // Navigate
  const navigate = useNavigate();
  const id = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const activity = useSelector((state) => state.activity.data);
  const farmer = useSelector((state) => state.farmer.data);
  const data = useSelector((state) => state.dailyActivity.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
  });
  const [activities, setActivities] = useState([]);
  const [dataActivities, setDataActivites] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = data.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setDataActivites([...data.docs[x].activities]);
        for (let i = 0; i < data.docs[x].activities.length; i++) {
          handleAddActivity(data.docs[x].activities[i]);
        }
        setFormData({
          farmerId: data.docs[x].farmerId ? data.docs[x].farmerId : "",
          farmerName: data.docs[x].farmerId
            ? data.docs[x].farmerId.fullName
            : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Activity
  const handleActivity = (index) => (e) => {
    const newItems = [...activities];
    newItems[index][e.target.name] = e.target.value;
    setActivities(newItems);
  };

  const handleAddActivity = (e) => {
    setActivities((prevItems) => [
      ...prevItems,
      {
        idActivity: e ? e.idActivity._id : "",
        description: e ? e.description : "",
      },
    ]);
    if (!e) {
      setDataActivites((prevItems) => [
        ...prevItems,
        {
          idActivity: "",
          description: "",
        },
      ]);
    }
  };

  const handleDeleteActivity = (value) => {
    let deletedData = [];
    for (let i = 0; i < activities.length; i++) {
      if (i !== value) {
        deletedData.push(activities[i]);
      }
    }
    setActivities(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Edit",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            farmerId: formData.farmerId,
            activities: activities,
          },
          id: id.id,
          token: token,
        };
        console.log(data);
        dispatch(updateDailyActivity(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getDailyActivityById(dataGetById)).then((result) => {
              dispatch(
                dailyActivityActions.editDailyActivity(result.payload.data)
              );
              toast.success(res.payload.message);
              navigate("/petani/aktifitas-harian");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      } else if (activity.totalDocs !== activity.docs.length && value === 2) {
        const getData = {
          params: {
            limit: activity.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getActivity(getData));
      }
    }
  };
  const activitiesColumn = ["AKTIFITAS", "DESKRIPSI", "AKSI"];
  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT AKTIFITAS HARIAN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerName && formData.farmerId.length > 0 && (
                <MenuItem value={formData.farmerId}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map(
                  (data, index) =>
                    (
                      <MenuItem value={data._id} key={index}>
                        {data.fullName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            AKTIFITAS HARI INI
          </Typography>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "10px",
            }}
          >
            <thead>
              {activitiesColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {activities.length > 0 &&
                activities.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            select
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            error={false}
                            name="idActivity"
                            onChange={handleActivity(index)}
                            defaultValue={
                              dataActivities[index]?.idActivity._id
                                ? dataActivities[index].idActivity._id
                                : ""
                            }
                            fullWidth
                            variant="outlined"
                            SelectProps={{
                              MenuProps: {
                                PaperProps: {
                                  onScroll: loadMore(2),
                                },
                                style: {
                                  height: "300px",
                                },
                              },
                            }}
                            style={{
                              maxWidth: "400px",
                              background: "white",
                              marginRight: "10px",
                            }}
                          >
                            {dataActivities[index].idActivity.activityName &&
                              dataActivities[index].idActivity._id.length >
                                0 && (
                                <MenuItem
                                  value={dataActivities[index].idActivity._id}
                                >
                                  {
                                    dataActivities[index].idActivity
                                      .activityName
                                  }
                                </MenuItem>
                              )}
                            {activity.docs.length > 0 ? (
                              activity.docs.map(
                                (data, index) =>
                                  data._id !==
                                    dataActivities[index]?.idActivity._id && (
                                    <MenuItem value={data._id} key={index}>
                                      {data.activityName}
                                    </MenuItem>
                                  )
                              )
                            ) : (
                              <MenuItem value="">Data kosong</MenuItem>
                            )}
                          </TextField>
                        </FormControl>
                      </td>
                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            inputProps={{ maxLength: 25 }}
                            error={false}
                            name="description"
                            id={index}
                            onChange={handleActivity(index)}
                            defaultValue={
                              dataActivities[index]?.description
                                ? dataActivities[index].description
                                : ""
                            }
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>
                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddActivity("")}
                          />
                          {activities.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleDeleteActivity(index)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/aktifitas-harian")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
